import React from 'react';

import { useRouter } from 'next/router';
import { compact } from 'lodash';
import { useSelector } from 'react-redux';
import { Router } from '../../../src/i18n';
import route, { companiesPaths } from '../../../constants/routes';
import { getQueryParamFromPath, getRouteWithCountryAndSlug } from '../../../utils/common';
import { TP } from '../../../constants/consts';
import FbTabs from '../../../components/FbTabs';
import EditSeasons from './EditSeasons';
import EditCompany from './EditCompany';
import EditStubPageHeader from '../../../components/EditComponents/EditStubPageHeader';
import { selectCompanyData } from '../selectors';

export const companyEditTabValues = {
  edit: 'edit',
  seasons: 'seasons',
  prod_rent: 'prod_rent',
};

const editTabs = [
  { name: `${TP}.FN_COMPANY_EDIT`, value: companyEditTabValues.edit },
  { name: `${TP}.m_SEASON`, value: companyEditTabValues.seasons },
  // { name: `${TP}.FN_PRODUCTION_RENTALS`, value: companyEditTabValues.prod_rent },
];

const CompanyFork = () => {
  const NextRouter = useRouter();
  const companyData = useSelector(selectCompanyData());
  const [tabValue, setTabValue] = React.useState(
    getQueryParamFromPath(NextRouter.asPath, 'tab') || companyEditTabValues.edit,
  );
  const notReadyTabs = { ...companyEditTabValues };
  delete notReadyTabs.seasons;
  delete notReadyTabs.edit;

  const setSelectedTab = value => {
    Router.push(companiesPaths.edit, `${getRouteWithCountryAndSlug(route.COMPANIES, companyData)}/edit?tab=${value}`, {
      shallow: true,
    });
    setTabValue(value);
  };

  return (
    <>
      <EditStubPageHeader
        entity={companyData}
        backToLinkProps={{ href: route.COMPANIES, as: route.COMPANIES }}
        backToLinkText={`${TP}.m_BACK_TO_COMPANIES`}
        entityInfo={compact([companyData?.country?.name, companyData?.city?.name]).join(', ')}
        viewModeLinkProps={{
          href: companiesPaths.company,
          as: getRouteWithCountryAndSlug(route.COMPANIES, companyData),
        }}
      />
      <FbTabs tabs={editTabs} initialTabValue="seasons" value={tabValue} onChange={setSelectedTab} />
      <section style={{ marginTop: 30 }}>
        {tabValue === companyEditTabValues.seasons && <EditSeasons companyData={companyData} />}
        {tabValue === companyEditTabValues.edit && <EditCompany company={companyData} />}
        {Object.values(notReadyTabs).includes(tabValue) && <div>Under construction</div>}
      </section>
    </>
  );
};

export default CompanyFork;
